import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { BaseSocialShareButton } from '../base-social-share-button/base-social-share-button';
import { getTranslation } from '../../../util/translation/get-translation';
import { encodeQuery } from '../../../util/url/encode-query.util';
import { TwitterIcon } from '../../icons';

interface ITwitterShareButtonProps {
  size?: 'large' | 'small';
  inviteText?: string;
  via?: string;
  hashTags?: string[];
  showButton: boolean;
}

const twitterLink = (url, title, via, hashtags = []) => {
  return 'https://twitter.com/share?' + encodeQuery({
    url,
    text: title,
    via,
    hashtags: hashtags.join(',')
  });
};

export const TwitterShareButton = inject('state', 'dispatch')(observer((props: ITwitterShareButtonProps & IInjectedProps) => {
  return (
    <BaseSocialShareButton
      backgroundColor="#1b95e0"
      icon={<TwitterIcon/>}
      text="Tweet"
      size={props.size}
      showButton={props.showButton}
      onClick={() => {
        props.dispatch.openPopupWindow(
          twitterLink(window.location.href, props.inviteText, props.via, props.hashTags),
          getTranslation(props.state.configuration, 'social-buttons.share-on-twiter-popup-title'));
      }}
    />
  );
}));
